import type { ComponentProps, ReactNode } from 'react';

import { MultiSelect } from 'components/Select/MultiSelect';

import { Field } from './Field/Field';

type Props = {
  qaId?: string;
  maxSelected?: number | null | undefined;
  disabled?: boolean;
  name: string;
  label?: string;
  hint?: ReactNode;
  description?: ReactNode;
  options: {
    value: string;
    label: string;
  }[];
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  onChange?: (...args: any[]) => any;
  onFocus?: () => void;
  placeholder?: string;
  menuPortalTarget?: ComponentProps<typeof MultiSelect>['menuPortalTarget'];
  menuPosition?: ComponentProps<typeof MultiSelect>['menuPosition'];
};

export function MultiSelectField({
  name,
  label,
  description,
  options,
  hint,
  onChange,
  onFocus,
  menuPortalTarget,
  menuPosition,
  qaId,
  ...props
}: Props) {
  return (
    <Field
      inputProps={{ ...props, options }}
      name={name}
      label={label}
      description={description}
      renderInput={({ value, id, qaId: fieldQaId, updateValue }) => (
        <>
          {hint ?? null}
          <MultiSelect
            id={id}
            name={name}
            value={value}
            options={options}
            qaId={qaId ?? fieldQaId}
            onChange={(e) => {
              // Ensure we're not losing values when updating
              updateValue(e);

              if (onChange) {
                onChange(e);
              }
            }}
            onFocus={onFocus}
            label={label}
            menuPortalTarget={menuPortalTarget}
            menuPosition={menuPosition}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        </>
      )}
    />
  );
}
